
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: {
    StoryblokComponent,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok.background

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.animate()
    })
  },
  methods: {
    animate() {
      const mm = this.$gsap.matchMedia(this.$refs.container)

      mm.add('(min-width: 1024px)', () => {
        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            // markers: true,
            start: 'top 90%',
            end: 'bottom 20%',
            toggleActions: 'play none none reverse',
          },
        })

        tl.from(
          '.leftCard',
          {
            opacity: 0,
            x: 50,
            // scale: 0.8,
            // stagger: 0.1,
            duration: 0.4,
          },
          0
        )
        tl.from(
          '.rightCard',
          {
            opacity: 0,
            x: -50,
            // scale: 0.8,
            // stagger: 0.1,
            duration: 0.4,
          },
          0
        )
      })
    },
  },
}
